var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"10px","background":"#fff"}},[_c('ms-checkbox-group',{attrs:{"button":"","round":"20px"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_c('ms-checkbox',{attrs:{"disabled":"","label":"1"}},[_vm._v("test1")]),_c('ms-checkbox',{attrs:{"label":"2"}},[_vm._v("test2")]),_c('ms-checkbox',{attrs:{"label":"3"}},[_vm._v("test3")])],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5515da2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkbox.vue
// module id = null
// module chunks = 